import React, { useEffect, useState } from 'react'

import { Section } from '../../../..'
import { useStudents, useUser } from '../../../../../context'
import { getRoutinesNames } from '../../../../../firebase/utils/routines'
import { Student } from '../../../../../types'
import MPlayer from '../../../../musicPlayer/MPlayer'
import { Routines } from '../../../professors/Students/RoutineSection'

const StudentRoutine = () => {
  const { user } = useUser()
  const { setActiveStudent } = useStudents()

  useEffect(() => {
    setActiveStudent(user as Student)
  }, [user])

  const { studentLogs } = useStudents()
  const [exerByCat, setExerByCat] = useState<Routines[] | null>(null)

  useEffect(() => {
    studentLogs && getRoutinesNames(studentLogs, setExerByCat)
  }, [studentLogs])

  const hasContent =
    exerByCat?.some((routine) => routine.content.length > 0) ?? false

  return (studentLogs?.length ?? 0) > 0 && exerByCat && hasContent ? (
    <Section title="Tu Rutina!" childrenClass="full-space-section" withBackBtn>
      {exerByCat && <MPlayer routines={exerByCat} />}
    </Section>
  ) : (
    <Section
      title="Tu Rutina!"
      subtitle="Aun no tienes una rutina cargada"
      children={null}
      withBackBtn
    />
  )
}

export default StudentRoutine
